import { isSuggestionsLoading } from '@/redux/selectors/aiSelectors.js';
import { pathname as pathnameSelector } from '@/redux/selectors/uiSelectors.js';
import { useSelector } from 'react-redux';
// import AiSuggestionsStateHandler from './aiSuggestions/AiSuggestionsStateHandler.jsx';
import AiSuggestionsTrigger from './AiSuggestionsTrigger.jsx';

const AiSuggestions = () => {
  const isAppsScreen = useSelector((state) => pathnameSelector(state)?.startsWith('/apps'));
  const isLoading = useSelector(isSuggestionsLoading);

  if (!isAppsScreen) {
    return null;
  }

  return (
    <>
      <AiSuggestionsTrigger //
        loading={isLoading}
        hasSuggestions={isLoading}
        showCount
      />
      {/* <AiSuggestionsStateHandler /> */}
    </>
  );
};
export default AiSuggestions;
